import React, { useState, useEffect } from "react";
import Layout from "./Layout";
import { useLocation, useNavigate, useParams } from "react-router-dom/dist";
import { addDoc, collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../config/firebase";
import {
  createInitialForm,
  fetchLatestId,
  updateLatestId,
  validateRequiredField,
} from "../../../common/common";
import { userSelectedData } from "../../../assets/lib/user.js";
import { COLLECTION, COLLECTION_COUNTER } from "../../../data/constant";
import { routes } from "../../../routing/routes";

const UserInfo = () => {
  const { userDocId } = useParams();
  const navigate = useNavigate();
  const [isEdit, setIsEdit] = useState(false);
  const [isNewAdd, setIsNewAdd] = useState(true);
  const { state: locationState } = useLocation();
  const [userState, setUserState] = useState(createInitialForm(userSelectedData));
  const [errorFields, setErrorFields] = useState([]);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [errorOnFetch, setErrorOnFetch] = useState(false);

  const handleSubmitModal = async () => {
    const error = validateRequiredField(userSelectedData, userState);
    setErrorFields(error);
    setSubmitLoading(true);

    if (error.length === 0) {
      try {
        if (isEdit && userDocId) {
          const docRef = doc(db, COLLECTION.USER, userDocId);
          await updateDoc(docRef, userState);
        } else {
          const userCollectionRef = collection(db, COLLECTION.USER);
          await addDoc(userCollectionRef, userState);
          await updateLatestId(COLLECTION_COUNTER.USER, userState.no);
        }
        navigate(routes.USER_MANAGEMENT);
      } catch (error) {
        console.log("error", error);
        setErrorOnFetch(true);
      }
    }
    setSubmitLoading(false);
  };

  const getUserInput = (event) => {
    if (!isEdit && !isNewAdd) return;

    const name = event.target.name;
    let value = event.target.value;
    const inputType = event.target.type;

    if (value && inputType === "number") value = parseInt(value);

    if (errorFields.includes(name) && value) {
      setErrorFields((prev) => prev.filter((key) => key !== name));
    }

    setUserState((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    setIsEdit(locationState?.edit || false);
    setIsNewAdd(locationState?.add || false);

    const fetchingInfo = async () => {
      setFetchLoading(true);

      try {
        if (locationState?.add) {
          const latestId = await fetchLatestId(COLLECTION_COUNTER.USER);
          setUserState((prev) => ({ ...prev, [userSelectedData.no.key]: latestId }));
        } else {
          const docRef = doc(db, COLLECTION.USER, userDocId);
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
            const storedData = docSnap.data();
            setUserState((prev) => {
              const stateObj = { ...prev };
              Object.keys(stateObj).forEach((k) => {
                if (storedData[k] !== undefined) stateObj[k] = storedData[k];
              });
              return stateObj;
            });
          }
        }
      } catch (error) {
        console.log(error);
        setErrorOnFetch(true);
      }

      setFetchLoading(false);
    };

    fetchingInfo();
  }, []);

  return (
    <Layout
      isNewAdd={isNewAdd}
      isEdit={isEdit}
      setIsEdit={setIsEdit}
      getUserInput={getUserInput}
      userState={userState}
      handleSubmitModal={handleSubmitModal}
      errorFields={errorFields}
      fetchLoading={fetchLoading}
      submitLoading={submitLoading}
      errorOnFetch={errorOnFetch}
    />
  );
};

export default UserInfo;
